import React from "react";

const BUTTON_HEIGHT = 30;

/**
 * Section buttons for adding/editing Task and Note sections
 */
const SectionButtons = ({
  hasTask,
  hasNote,
  savedNote,
  onTaskClick,
  onNoteClick,
  hoveredButton,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <div style={{ display: "flex", gap: "6px", marginBottom: "10px" }}>
      <div
        style={{
          width: "100%",
          height: BUTTON_HEIGHT,
          backgroundColor: "white",
          borderRadius: "3px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          border: "2px solid gray",
        }}
        onClick={onTaskClick}
        onMouseEnter={() => onMouseEnter("task")}
        onMouseLeave={onMouseLeave}
      >
        <span style={{ color: "gray", fontSize: "13px" }}>
          {hasTask ? "Edit Task Section" : "+ Task Section"}
        </span>
      </div>

      {!savedNote && (
        <div
          style={{
            width: "100%",
            height: BUTTON_HEIGHT,
            backgroundColor: "white",
            borderRadius: "3px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            border: "2px solid gray",
          }}
          onClick={onNoteClick}
          onMouseEnter={() => onMouseEnter("note")}
          onMouseLeave={onMouseLeave}
        >
          <span style={{ color: "gray", fontSize: "13px" }}>
            {hasNote ? "Edit Note Section " : "+ Note Section"}
          </span>
        </div>
      )}
    </div>
  );
};

export default SectionButtons;
